import { Geolocation } from '~/models/common/types'
import { GeocodingSearchLocation } from '~/models/location/geocoding'

export function geolocationToGoogleGeolocation(
  geolocation: Geolocation
): google.maps.LatLngLiteral {
  return {
    lat: geolocation.lat,
    lng: geolocation.lon
  }
}

export function geolocationsEqual(
  geoA: Geolocation,
  geoB: Geolocation
): boolean {
  return geoA.lat === geoB.lat && geoA.lon === geoB.lon
}

export function createSearchGeolocationString(
  geolocation: GeocodingSearchLocation
): string {
  const {
    geolocation: { lat, lon },
    radius,
    name,
    id
  } = geolocation
  return `${lat}-${lon}-${radius}-${name}-${id}`
}
